import { render, staticRenderFns } from "./Actives.vue?vue&type=template&id=4bc40b5d&scoped=true&"
import script from "./Actives.vue?vue&type=script&lang=js&"
export * from "./Actives.vue?vue&type=script&lang=js&"
import style0 from "./Actives.vue?vue&type=style&index=0&id=4bc40b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc40b5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
